export type CustomFormAnswer = {
  [key: string]: string;
};

export type CustomFormTemplateBody =
  | CustomFormTemplateRichTextBlock
  | CustomFormTemplateInputText
  | CustomFormTemplateInputDate
  | CustomFormTemplateInputTime
  | CustomFormTemplateInputNumber
  | CustomFormTemplateInputChoiceSet
  | CustomFormTemplateInputToggle
  | CustomFormTemplatePeoplePicker
  | CustomFormTemplateStatus
  | CustomFormTemplateRequester
  | CustomFormTemplateDueDate
  | CustomFormTemplateTeam
  | CustomFormTemplateAddComment
  | CustomFormTemplateAddAttachment
  | CustomFormTemplateTicket;

export type CustomTypeTemplateBase = {
  type: string;
  id: string;
  value?: string;
};

export type CustomFormTemplateInputText = CustomTypeTemplateBase & {
  type: "Input.Text";
  placeholder?: string;
  label?: string;
};

export type CustomFormTemplateInputDate = CustomTypeTemplateBase & {
  type: "Input.Date";
};

export type CustomFormTemplateInputTime = CustomTypeTemplateBase & {
  type: "Input.Time";
};

export type CustomFormTemplateInputNumber = CustomTypeTemplateBase & {
  type: "Input.Number";
};

type ChoiceSetChoice = {
  title: string;
  value: string;
};

export type CustomFormTemplateInputChoiceSet = CustomTypeTemplateBase & {
  type: "Input.ChoiceSet";
  placeholder?: string;
  choices: ChoiceSetChoice[];
};

export type CustomFormTemplateInputToggle = CustomTypeTemplateBase & {
  type: "Input.Toggle";
  title: string;
};

export type CustomFormTemplatePeoplePicker = CustomTypeTemplateBase & {
  type: "People Picker";
  label?: string;
  displayLabel?: string;
  selectionMode?: "single" | "multiple";
};

export type CustomFormTemplateRichTextBlock = {
  type: "RichTextBlock";
  inlines: {
    type: "TextRun";
    text: string;
  }[];
};

export type CustomFormTemplateStatus = CustomTypeTemplateBase & {
  type: "Status";
  displayLabel?: string;
};

export type CustomFormTemplateRequester = CustomTypeTemplateBase & {
  type: "Requester";
  label?: string;
  displayLabel?: string;
};

export type CustomFormTemplateDueDate = CustomTypeTemplateBase & {
  type: "Due Date";
  displayLabel?: string;
};

export type CustomFormTemplateTeam = CustomTypeTemplateBase & {
  type: "Team";
  displayLabel?: string;
};

export type CustomFormTemplateAddComment = {
  type: "Add Comment";
  id: string;
  displayLabel?: string;
};

export type CustomFormTemplateAddAttachment = {
  type: "Add Attachment";
  id: string;
  displayLabel?: string;
};

export type CustomFormTemplate = {
  body: CustomFormTemplateBody[];
};

export type MgtUser = {
  AadObjectId: string;
  FullName: string;
  UserName: string;
};

export const CustomFormTypesExcempt = [
  "RichTextBlock",
  "ActionSet",
  "Add Comment",
  "Add Attachment",
];

export type CustomFormTemplateTicket = CustomTypeTemplateBase & {
  type:
    | "Due Date"
    | "Resolution Date"
    | "Status"
    | "Requester"
    | "Team"
    | "Affected Users"
    | "Ticket Type"
    | "Priority"
    | "Group"
    | "Collaborators"
    | "Category"
    | "Tags"
    | "Assignment"
};
